import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const PromoTilesContainer = Loadable(() => import('../../containers/web/promoTilesContainer'));
export default MapTo('vcg/components/soe-home/react/promoTiles')(PromoTilesContainer);
